import script from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=3717c6b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3717c6b9"]])

export default __exports__